/**
 * API чтения `public.pts_data` для админки.
 *
 * Запись pts_data — только из мобильного приложения инспектора (см.
 * `lib/services/orders_repository.dart::upsertPtsData`). Админка только читает,
 * чтобы отрисовать блок «ПТС» на карточке заказа.
 */
import { mockState } from '@/api/mock-data'
import { createClient } from '@/api/supabase'
import { USE_MOCK } from '@/config'
import type { PtsData } from '@/types/pts'

export async function getPtsData(orderId: string): Promise<PtsData | null> {
  if (USE_MOCK) {
    const ptsByOrder = (mockState as unknown as { ptsData?: PtsData[] }).ptsData
    return ptsByOrder?.find((p) => p.order_id === orderId) ?? null
  }
  const supabase = createClient()
  const { data, error } = await supabase
    .from('pts_data')
    .select('*')
    .eq('order_id', orderId)
    .maybeSingle()
  if (error) {
    if (error.code === 'PGRST116') return null
    throw new Error(error.message)
  }
  return (data as PtsData) ?? null
}
